<template>
  <b-modal
    id="createProcedure"
    size="lg"
    title="Crear procedure:"
    hide-footer
    @shown="onModalShown"
  >
    <form
      @submit.prevent="submit"
      v-promise-btn="{ action: 'submit' }"
      ref="form"
    >
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="Nom_Procedure" class="label"
                >Nombre del Procedure</label
              >
              <input
                type="text"
                class="form-control"
                name="nombre del procedure"
                id="Nom_Procedure"
                v-model="procedure.nombre"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="Comantario" class="label">Comentario</label>
              <input
                type="text"
                class="form-control"
                name="comentario"
                id="Comentario"
                v-model="procedure.comentarios"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="w-100 d-flex justify-content-end">
        <button
          type="button"
          class="btn btn-danger"
          @click="$bvModal.hide('createProcedure')"
        >
          Cancelar
        </button>
        <button type="submit" class="btn btn-primary">Guardar</button>
      </div>
    </form>
  </b-modal>
</template>
<script>
import axios from "axios";
export default {
  name: "create-procedure",
  data: () => ({
    procedure: {
      nombre: null,
      comentarios: null,
    },
  }),
  methods: {
    async submit() {
      if (!this.isValidForm()) {
        this.$msgBoxOk("Por favor, complete los campos correctamente");
        return;
      }

      try {
        const resp = await axios.post("/execute", {
          method: "SEC.CrearProcedure",
          parameters: [
            { name: "nombre", value: this.procedure.nombre },
            { name: "comentarios", value: this.procedure.comentarios },
          ],
        });
        if (resp.data.ok) {
          this.$bvModal.hide("createProcedure");
          this.$emit("update");
        } else {
          this.$msgBoxOk(resp.data.message);
        }
      } catch (error) {
        this.$msgBoxOk(error.message);
      }
    },
    isValidForm() {
      return !!this.procedure.nombre && !!this.procedure.comentarios;
    },
    onModalShown() {
      this.procedure.nombre = null;
      this.procedure.comentarios = null;
    },
  },
};
</script>
<style scoped></style>
